import { Routes, Route } from 'react-router-dom'

import './App.css';
import Intro from '../intro/intro'
import NotFoundPage from '../notfoundpage/notfoundpage'

// Main Rugby
import MainRugby from '../main-rugby/main-rugby';
import RugbyNews from '../main-rugby/news/rugby-news';
import RugbyTeams from '../main-rugby/teams/rugby-teams'
import RugbyCoaches from '../main-rugby/coaches/rugby-coaches';
import RugbyResults from '../main-rugby/results/rugby-results';
import RugbyPartners from '../main-rugby/partners/rugby-partners';
import RugbyStats from '../main-rugby/stats/rugby-stats';
import PlayerBio from '../main-rugby/teams/players/players'
import FirstPlayer from '../main-rugby/players/FirstPlayer/firstplayer';
// ###########


// Main Football

// #############


// Main Crossfit

// #############


// Main Esport

// ###########




function App() {


  return (
    <div className='app'>
      <Routes>
        <Route exact path='/' element={<Intro/>} />
        <Route path='*' element={<NotFoundPage/>} />


        {/* Main Rugby */}
        <Route exact path='/rugby' element={<MainRugby/>} />
        
        <Route path='/rugby-news' element={<RugbyNews />} />
        <Route path='/rugby-team' element={<RugbyTeams />} />
        <Route path='/rugby-results' element={<RugbyResults />} />
        <Route path='/rugby-coaches' element={<RugbyCoaches />} />
        <Route path='/rugby-partners' element={<RugbyPartners />} />
        <Route path='/rugby-stats' element={<RugbyStats />} />

        {/* rugby players */}
        <Route path='/name1' element={<FirstPlayer />} />

        {/* Main Football */}
        

      </Routes>

    </div>
  );
}





export default App;
